{
  "settings.title": "Instellingen",
  "settings.tabs": "Onderdelen van instellingen",
  "settings.team.tab": "Team",
  "settings.team.col_member": "Lid",
  "settings.team.col_role": "Rol",
  "settings.team.col_review": "Reviewtalen",
  "settings.team.col_access": "Toegang",
  "settings.team.col_open": "Openen",
  "settings.team.col_permission": "Recht",
  "settings.team.you": "(jij)",
  "settings.team.no_review": "Geen",
  "settings.team.permanent": "Vast lid",
  "settings.team.support": "Ondersteuning",
  "settings.team.support_expired": "Verlopen",
  "settings.team.expires_at": "Tot {date}",
  "settings.team.expired_at": "Verlopen op {date}",
  "settings.team.support_title": "{count, plural, one {# persoon met tijdelijke ondersteuningstoegang} other {# personen met tijdelijke ondersteuningstoegang}}",
  "settings.team.support_body": "Ondersteuningstoegang vervalt automatisch op de vervaldatum. Handelingen staan, zoals bij ieder lid, in het auditlog.",
  "settings.team.matrix": "Wat elke rol mag",
  "settings.team.matrix_body": "Dezelfde rechtenmatrix die de server bij elke handeling controleert.",
  "settings.team.allowed": "Toegestaan",
  "settings.team.not_allowed": "Niet toegestaan",
  "settings.team.empty_title": "Geen teamleden",
  "settings.team.empty_body": "Er zijn nog geen leden in deze organisatie.",
  "settings.team.saved": "{name} bijgewerkt",
  "settings.team.save": "Opslaan",
  "settings.team.review_hint": "In deze talen keurt dit lid vertalingen goed.",
  "settings.team.review_hint_no_right": "De rol {role} keurt geen vertalingen goed; reviewtalen tellen pas met een rol die dat mag.",
  "settings.team.last_owner_title": "Enige eigenaar",
  "settings.team.last_owner_body": "Maak eerst iemand anders eigenaar; daarna kan deze rol veranderen.",
  "settings.team.no_rights_title": "Alleen-lezen",
  "settings.team.no_rights_body": "Alleen eigenaren en beheerders wijzigen rollen en reviewtalen.",
  "settings.team.support_readonly_title": "Tijdelijke ondersteuningstoegang",
  "settings.team.support_readonly": "Reden: {reason}. Deze toegang wijzig je niet hier; hij vervalt vanzelf.",
  "settings.conflict_body": "Je invoer is behouden. Opnieuw laden vervangt je wijzigingen.",
  "settings.team.conflict_title": "Intussen gewijzigd",
  "settings.team.conflict_body": "Iemand anders heeft {name} gewijzigd terwijl jij bezig was.",
  "settings.team.conflict_now": "Nu opgeslagen",
  "settings.team.conflict_yours": "Jouw keuze",
  "settings.team.conflict_reload": "Nieuwste laden",
  "settings.team.conflict_keep": "Mijn keuze opslaan",
  "settings.team.error.last_owner": "De laatste eigenaar houdt de eigenaarsrol. Maak eerst iemand anders eigenaar.",
  "settings.team.error.support_member": "Ondersteuningstoegang wijzig je niet via het team; die vervalt vanzelf.",
  "settings.team.role_hint.owner": "Alles, ook team, export en de eigenaarsrol",
  "settings.team.role_hint.admin": "Alles behalve de eigenaarsrol toekennen",
  "settings.team.role_hint.agent": "Aanbod, beeld, teksten, contacten en dry-runs",
  "settings.team.role_hint.editor": "Aanbod, beeld en teksten; contacten alleen lezen",
  "settings.team.role_hint.reviewer": "Vertalingen schrijven en goedkeuren in de eigen reviewtalen",
  "settings.team.role_hint.viewer": "Alleen bekijken",
  "settings.perm.property.read": "Aanbod bekijken",
  "settings.perm.property.write": "Aanbod bewerken",
  "settings.perm.property.publish": "Woningrechten vastleggen",
  "settings.perm.media.write": "Beeld beheren",
  "settings.perm.localization.write": "Vertalingen schrijven",
  "settings.perm.localization.review": "Vertalingen goedkeuren",
  "settings.perm.import.run": "Dry-run starten",
  "settings.perm.import.apply": "Imports toepassen en bronnen beheren",
  "settings.perm.channel.manage": "Portalen beheren",
  "settings.perm.crm.read": "Contacten en aanvragen bekijken",
  "settings.perm.crm.write": "Contacten en aanvragen bewerken",
  "settings.perm.site.publish": "Website publiceren en terugzetten",
  "settings.perm.site.withdraw": "Spoedintrekking",
  "settings.perm.ai.use": "AI-assistent gebruiken",
  "settings.perm.settings.manage": "Instellingen en volledige export",
  "settings.perm.team.manage": "Team beheren",
  "settings.perm.audit.read": "Auditlog lezen",
  "settings.audit.tab": "Auditlog",
  "settings.audit.col_time": "Tijd",
  "settings.audit.col_action": "Gebeurtenis",
  "settings.audit.col_actor": "Door",
  "settings.audit.col_object": "Object",
  "settings.audit.object_type": "Soort object",
  "settings.audit.all_types": "Alle soorten",
  "settings.audit.clear": "Filters wissen",
  "settings.audit.filter_object": "Alleen dit object",
  "settings.audit.filter_object_id": "Alleen gebeurtenissen van object {id}",
  "settings.audit.open_object": "Openen",
  "settings.audit.empty_title": "Nog geen gebeurtenissen",
  "settings.audit.empty_body": "Wijzigingen verschijnen hier met tijd en wie ze deed.",
  "settings.audit.empty_filtered_title": "Niets gevonden",
  "settings.audit.empty_filtered_body": "Geen gebeurtenissen voor dit filter.",
  "settings.audit.no_rights_title": "Geen toegang tot het auditlog",
  "settings.audit.no_rights_body": "Alleen eigenaren en beheerders lezen het auditlog.",
  "settings.audit.search": "Auditlog doorzoeken",
  "settings.audit.search_placeholder": "Details of object-ID",
  "settings.audit.area_label": "Gebied",
  "settings.audit.all_areas": "Alle gebieden",
  "settings.audit.all_actors": "Iedereen",
  "settings.audit.object_filter_clear": "Filter op object {id} wissen",
  "settings.audit.area.properties": "Aanbod",
  "settings.audit.area.localization": "Talen",
  "settings.audit.area.crm": "Klanten",
  "settings.audit.area.imports": "Imports",
  "settings.audit.area.channels": "Portalen",
  "settings.audit.area.website": "Website",
  "settings.audit.area.team": "Team",
  "settings.audit.area.ai": "AI",
  "settings.audit.area.organization": "Organisatie",
  "settings.object.property": "Woning",
  "settings.object.site": "Website",
  "settings.object.connector_account": "Portaalkanaal",
  "settings.object.import_run": "Importrun",
  "settings.object.import_source": "Importbron",
  "settings.object.localized_revision": "Vertaling",
  "settings.object.content_unit": "Tekst",
  "settings.object.lead": "Aanvraag",
  "settings.object.contact": "Contact",
  "settings.object.task": "Taak",
  "settings.object.shortlist": "Selectie",
  "settings.object.media_asset": "Beeld",
  "settings.object.appointment": "Afspraak",
  "settings.object.locale": "Taal",
  "settings.object.shortlist_share": "Gedeelde selectie",
  "settings.object.tenant": "Organisatie",
  "settings.object.area": "Gebied",
  "settings.object.term_entry": "Term",
  "settings.object.membership": "Teamlid",
  "settings.object.team_invitation": "Teamuitnodiging",
  "settings.export.tab": "Export",
  "settings.export.title": "Volledige export",
  "settings.export.lead": "Alle gegevens van {org} in één JSON-bestand, voor overstap of archief.",
  "settings.export.format": "JSON, formaat bres_export_v1",
  "settings.export.download": "Export downloaden",
  "settings.export.included_title": "Zit erin",
  "settings.export.excluded_title": "Zit er niet in",
  "settings.export.included.listings": "Woningen, aanbiedingen, privégegevens en vergrendelde velden",
  "settings.export.included.rights": "Rechten per woning en kanaal",
  "settings.export.included.media": "Beeldregistratie en beeldrechten",
  "settings.export.included.texts": "Teksten, vertalingen met reviewstatus, termen en vertaalgeheugen",
  "settings.export.included.crm": "Contacten, toestemmingen, aanvragen, notities, taken, afspraken, woonwensen en selecties",
  "settings.export.included.imports": "Importbronnen en externe ID's",
  "settings.export.included.sites": "Organisatie, gebieden, websites, talen en gepubliceerde paden",
  "settings.export.excluded.passwords": "Wachtwoorden, sessies en tweestapscodes",
  "settings.export.excluded.secrets": "Sleutels en geheimen van koppelingen en portalen",
  "settings.export.excluded.media_files": "De beeldbestanden zelf (alleen de registratie)",
  "settings.export.excluded.audit": "Auditlog",
  "settings.export.excluded.jobs": "Achtergrondtaken, builds en portaalfeeds",
  "settings.export.done": "Export gedownload",
  "settings.export.summary": "{size}, {tables} tabellen, {rows} rijen, waarvan {properties} woningen en {contacts} contacten.",
  "settings.export.private_title": "Bevat privégegevens",
  "settings.export.private_body": "Eigenaren, adressen, commissies en contactgegevens van klanten staan in dit bestand. Bewaar het versleuteld en stuur het niet per mail.",
  "settings.export.no_rights_title": "Geen toegang tot de export",
  "settings.export.no_rights_body": "Alleen eigenaren en beheerders kunnen alle gegevens exporteren.",
  "settings.diagnostics.tab": "Diagnostiek",
  "settings.diagnostics.jobs": "Achtergrondtaken",
  "settings.diagnostics.refresh": "Verversen",
  "settings.diagnostics.col_kind": "Soort",
  "settings.diagnostics.col_status": "Status",
  "settings.diagnostics.col_count": "Aantal",
  "settings.diagnostics.col_error": "Laatste fout",
  "settings.diagnostics.no_jobs": "Nog geen achtergrondtaken.",
  "settings.diagnostics.notifications": "Meldingen per mail",
  "settings.diagnostics.no_notifications": "Nog geen meldingen verstuurd.",
  "settings.diagnostics.versions": "Versies",
  "settings.diagnostics.code": "Code",
  "settings.diagnostics.api": "API",
  "settings.diagnostics.node": "Node.js",
  "settings.diagnostics.database": "Database",
  "settings.diagnostics.ai": "AI-provider",
  "settings.diagnostics.problems": "{count, plural, one {# taak of melding mislukt} other {# taken of meldingen mislukt}}",
  "settings.diagnostics.problems_body": "Mislukte taken worden opnieuw geprobeerd; opgegeven taken vragen actie. Bekijk de laatste fout per soort.",
  "settings.diagnostics.dev_title": "Ontwikkelhulp",
  "settings.diagnostics.dev_body": "Alleen zichtbaar in de lokale ontwikkelomgeving.",
  "settings.diagnostics.chaos_label": "Mailstoring simuleren",
  "settings.diagnostics.chaos_active": "Verzenden naar de testmailbox faalt nu. Meldingen worden opnieuw geprobeerd zodra je dit uitzet.",
  "settings.diagnostics.chaos_on": "Mailstoring aan",
  "settings.diagnostics.chaos_off": "Mailstoring uit",
  "settings.diagnostics.mailpit": "Testmailbox openen",
  "settings.job_status.queued": "In wachtrij",
  "settings.job_status.running": "Bezig",
  "settings.job_status.succeeded": "Gelukt",
  "settings.job_status.failed": "Mislukt, wordt herhaald",
  "settings.job_status.dead": "Opgegeven",
  "settings.job_status.cancelled": "Geannuleerd",
  "settings.notification_status.pending": "Wacht",
  "settings.notification_status.sent": "Verzonden",
  "settings.notification_status.failed": "Mislukt",
  "settings.notification_status.dead": "Opgegeven",
  "settings.object.blog_post": "Blogartikel",
  "settings.object.blog_source": "Blogbron",
  "settings.object.ai_feature": "AI-functie",
  "settings.object.ai_job": "AI-taak",
  "settings.object.chat_conversation": "Chatgesprek",
  "settings.object.chat_knowledge": "Chatkennis",
  "settings.team.invite": "Teamlid uitnodigen",
  "settings.team.invite_name": "Naam",
  "settings.team.invite_send": "Uitnodiging versturen",
  "settings.team.invite_sent": "Uitnodiging verstuurd",
  "settings.team.invite_pending": "Openstaande uitnodigingen",
  "settings.team.invite_until": "Geldig tot",
  "settings.team.invite_revoke": "Uitnodiging intrekken",
  "settings.team.invite_revoke_body": "De uitnodiging voor {name} werkt daarna niet meer.",
  "settings.team.invite_revoked": "Uitnodiging ingetrokken",
  "settings.team.invite_invalid": "Uitnodiging niet beschikbaar",
  "settings.team.invite_invalid_body": "Deze uitnodiging is verlopen, ingetrokken of al gebruikt. Vraag je beheerder om een nieuwe uitnodiging.",
  "settings.team.invite_signin": "Log in om je uitnodiging voor {site} te accepteren.",
  "settings.team.invite_accept_title": "Welkom bij {site}",
  "settings.team.invite_accept": "Uitnodiging accepteren",
  "settings.team.invite_role": "Je krijgt de rol {role}.",
  "settings.team.invite_wrong_account": "Log eerst uit en log daarna in met het e-mailadres van de uitnodiging.",
  "settings.team.invite_password_hint": "Minimaal 12 tekens.",
  "settings.team.invite_password_repeat": "Wachtwoord herhalen",
  "settings.team.invite_password_mismatch": "De wachtwoorden zijn niet gelijk.",
  "settings.team.revoke": "Toegang intrekken",
  "settings.team.revoke_body": "{name} heeft daarna geen toegang meer tot deze organisatie. De opgeslagen gegevens blijven behouden.",
  "settings.team.access_revoked": "Toegang van {name} ingetrokken"
}
